module.exports = __webpack_public_path__ + "static/img/Entrance.a88fd93.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Entrance.gif
// module id = 3kY7
// module chunks = 0